'use strict';

/**
 * Model for saving the settings for the list view
 *
 * @category   Model
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Backbone = require('backbone');
var ModelLocal = require('base/Colido.ModelLocal');

var SettingsObjectListModel = ModelLocal.extend({
    defaults: {
        id: 1,
        viewModeDefault: 'showroom-grid',
        sortGrid: 'properName.asc',
        sortList: 'properName.asc',
    },

    syncedAttrs: [
        'viewModeDefault',
        'sortGrid',
        'sortList',
    ],

    /**
     * Name of the storage to use
     * @type {string|null}
     */
    storageKey: 'module:share:list',

    initialize: function(attributes, options) {
        ModelLocal.prototype.initialize.apply(this, arguments);

        var catalog = this.get('catalog');

        if (catalog) {
            this.defaults.sortGrid = catalog.get('fieldsDefaultSort');
            this.defaults.sortList = catalog.get('fieldsDefaultSort');
        }
        // Set viewMode to last used viewMode (list or grid) in default mode
        this.set('viewMode', this.get('viewModeDefault'), {silent: true});
    },

    toJSON: function(options) {
        return _.pick(this.attributes, this.syncedAttrs);
    },

    getPath: function (target, options) {
        var parts = [];

        var attrs = _.extend({}, this.attributes, options);

        if (attrs.setModel) {
            parts.push('sets');
            // Setting 'set' to `true` means that list of sets should be shown
            if (attrs.setModel instanceof Backbone.Model) {
                parts.push(attrs.setModel.id);
            }
        }

        // Set share token
        if (attrs.shareModel) {
            parts.push(attrs.shareModel.id);
        }

        if (target != null) {
            if (target instanceof Backbone.Model) {
                target = target.id
            }

            parts.push('show', target);
        }

        return parts.join('/')
    },

    /**
     * Overrides default set method to ensure incompatible states are not
     * used concurrently
     */
    set: function (key, val, options) {
        // Handle both `"key", value` and `{key: value}` -style arguments.
        var attrs;
        if (typeof key === 'object') {
            attrs = key;
            options = val;
        } else {
            (attrs = {})[key] = val;
        }

        attrs.activeModel = null;
        attrs.filter = null;
        attrs.controlMode = 'default';
        attrs.viewMode = 'showroom-grid';

        ModelLocal.prototype.set.call(this, attrs, options);

        if (this.localStorage) {
            this.save();
        }
    },
});

module.exports = SettingsObjectListModel;